import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { Toaster } from "./components/ui/toaster.tsx";
import { Toaster as Sonner } from "./components/ui/sonner.tsx";
import { TooltipProvider } from "./components/ui/tooltip.tsx";

// Contexts
import { AuthProvider } from "./components/AuthContext";
import { TokenProvider } from "./components/TokenContext";
import { ExamStatusProvider } from "./components/GATB/ExamStatusContext";
import { ScoreProvider } from "./components/GATB/ScoreContext";

// Layout & Pages
import Layout from "./components/Layout";
import PrivateRoute from "./components/PrivateRoute.js";
import PublicFallback from "./components/PublicFallback.js";

// Pages
import UserAccess from "./components/UserAccess.js";
import AutoLoginPage from "./components/AutoLoginPage.js";
import AdminDashboard from "./components/AdminDashboard.js";
import PrivacyPolicy from "./components/PrivacyPolicy.js";
import Personality from "./components/Personality.js";
import NameInput from "./components/Nameinput.js";

import Portal from "./components/Portal.js";
import Questionnaire from "./components/Questionnaire.js";
import Result from "./components/Result.js";
import GATBstart from "./components/GATB/GATBstart.js";
import GATBtest from "./components/GATB/GATBtest.js";
import GATBresult from "./components/GATB/GATBresults.js";
import Consultant from "./components/Consultant.js";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <TooltipProvider>
      <Toaster />
      <Sonner />
      <BrowserRouter>
        <AuthProvider>
          <TokenProvider>
            <ScoreProvider>
              <ExamStatusProvider>
                <Routes>
                  {/* ✅ ルートアクセス時の自動リダイレクト */}
                  <Route path="/" element={<Navigate to="/useraccess" replace />} />

                  {/* ✅ 公開ページ */}
                  <Route path="/useraccess" element={<UserAccess />} />
                  <Route path="/auto-login" element={<AutoLoginPage />} />
                  <Route path="/privacy-policy" element={<PrivacyPolicy />} />
                  {/*<Route path="/findjob-admin-dash-board" element={<AdminDashboard />} */}

                  {/* ✅ NameInput（Token 必須、Layout 無し） */}
                  <Route path="/nameinput" element={<PrivateRoute element={<NameInput />} />} />

                  {/* ✅ 保護されたルート（Layout含む） */}
                  <Route path="/portal" element={<Layout><PrivateRoute element={<Portal />} /></Layout>} />
                  <Route path="/questionnaire" element={<Layout><PrivateRoute element={<Questionnaire />} /></Layout>} />
                  <Route path="/result" element={<Layout><PrivateRoute element={<Result />} /></Layout>} />
                  <Route path="/GATBstart" element={<Layout><GATBstart /></Layout>} />
                  <Route path="/GATBtest" element={<Layout><PrivateRoute element={<GATBtest />} /></Layout>} />
                  <Route path="/GATBresult" element={<Layout><PrivateRoute element={<GATBresult />} /></Layout>} />
                  <Route path="/consultant" element={<Layout><PrivateRoute element={<Consultant />} /></Layout>} />
                  <Route path="/Personality-check-4-admin" element={<Layout><PrivateRoute element={<Personality />} /></Layout>} />

                  {/* ✅ フォールバック */}
                  <Route path="*" element={<PublicFallback />} />
                </Routes>
              </ExamStatusProvider>
            </ScoreProvider>
          </TokenProvider>
        </AuthProvider>
      </BrowserRouter>
    </TooltipProvider>
  </QueryClientProvider>
);

export default App;
